import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { ProductTypesStatisticsRow } from "../models/ProductTypesStatistics";

export interface GetProductTypesStatisticsParams {
	start: string;
	end: string;
	signal?: AbortSignal;
}

export const getProductTypesStatisticsData = async ({
	start,
	end,
	signal,
}: GetProductTypesStatisticsParams): Promise<ProductTypesStatisticsRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start },
		{ name: "End", value: end },
	];

	const resp = await apiService.callV2(
		"[KPI].[GetProductTypesStatisticsDataWeb]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(
			resp.message || "Error fetching product types statistics data",
		);
	}
	return get(resp, "data.tables[0].rows", []) as ProductTypesStatisticsRow[];
};
